export default function SubHeader({ text, bold }: header) {
  return (
    <p
      className={`text-[20px] font-${
        bold ? "semibold" : "medium"
      } text-gray-900`}
    >
      {text}
    </p>
  );
}

type header = {
  text: string;
  bold?: boolean;
};
